import "./style/index.css";
import Popup from './Popup';
export default Popup;
export { Popup };